// extracted by css-extract-rspack-plugin
export default {"section":"sox6y","rightSection":"HPi7k","leftSection":"a1tkH"};